import { useCallback, useEffect, useState } from 'react';
import { buildRechargeReportFilename, formatAccrualPeriod, resolveOrderIdentifier } from '../utils/fileNamingUtils';
import { useEmissorOrderReportPdf } from './useEmissorOrderReportPdf';
export function useEmissorReportDownloadFlow(contractId, contractLegalName) {
    const [showReportError, setShowReportError] = useState(false);
    const [isReportLoadingToastDismissed, setIsReportLoadingToastDismissed] = useState(false);
    const { isError: isReportError, isLoading: isReportLoading, fetchReport } = useEmissorOrderReportPdf();
    const showReportLoadingToast = isReportLoading && !isReportLoadingToastDismissed;
    useEffect(() => {
        if (isReportError) {
            setShowReportError(true);
        }
    }, [isReportError]);
    const handleDownloadReport = useCallback((order) => {
        if (!contractId) {
            return;
        }
        setShowReportError(false);
        setIsReportLoadingToastDismissed(false);
        const filename = buildRechargeReportFilename(contractLegalName ?? '', formatAccrualPeriod(order.competenceDate), resolveOrderIdentifier(order.description, order.protocol));
        fetchReport({ contractId, orderId: order.id }, filename);
    }, [contractId, contractLegalName, fetchReport]);
    const handleCloseReportLoadingToast = useCallback(() => {
        setIsReportLoadingToastDismissed(true);
    }, []);
    const handleCloseReportErrorToast = useCallback(() => {
        setShowReportError(false);
    }, []);
    return {
        showReportLoadingToast,
        showReportError,
        handleDownloadReport,
        handleCloseReportLoadingToast,
        handleCloseReportErrorToast,
    };
}
